import * as React from 'react'
import Svg from '@eversports/klimt-primitives/Svg'

import LocationIcon from '../assets/location.svg'

const LocationSvg = ({ size }: { size: number }) => <Svg src={LocationIcon} width={size} height={size} />

export default LocationSvg
